import i18n from "../../i18n/i18n"

export enum ApplicationEventType {
    NotSet = 0,
    ApplicationCreated = 1,
    ApplicationEdited = 3,
    ApplicationRequirementsFulfilled = 4,
    ApplicationRejected = 5,
    ApplicationReadyForCardProduction = 6,
    ApplicationSentToCardProduction = 7,
    ApplicationCertificateIssued = 8,
    ApplicationCertificateExpired = 9,
    ApplicationRequestedReplacementCancellation = 10,
    ApplicationRequestedRenewalCancellation = 11,
    ApplicationRequestedChangeCancellation = 12,
    CertificateRevokedCancellation = 13,
    ApplicationSubmitted = 14,
    ApplicationPaymentReceivedOnlinePaymentForCitizen = 15,
    ApplicationPaymentReceivedCash = 16,
    ApplicationPaymentReceivedGiroForm = 17,
    ApplicationPaymentReceivedElectronicInvoice = 18,
    ApplicationPaymentReceivedMobilePay = 19,
    ApplicationInvoiceLetterCreated = 20,
    CitizenSubmitApplicationSentToFrends = 21,
    EducationalInstitutionSubmitApplicationSentToFrends = 22,
    TemporaryCertificateAndPaymentRequestSentToFrends = 23,
    ApplicationCreatedDueToSelfServiceExemption = 24,
    ApplicationResubmittedByCitizen = 25,
    ApplicationReturnedToCitizenForResubmittal = 26,
    CitizenResubmitApplicationForTaxSentToFrends = 27,
    ApplicationCreatedByCaseWorkerOnBehalfOfCitizen = 28,
    ApplicationCreatedForReorderingOfCertificate = 29,
    TemporaryCertificateWithoutPaymentRequestSentToFrends = 30,
    CaseworkerReordersReplacementApplicationSentToFrends = 31,
    ApplicationReturnedToEducationalInstitutionForResubmittal = 32,
    ApplicationResubmittedByEducationalInstitution = 33,
    EducationalInstitutionResubmitApplicationForTaxSentToFrends = 34,
    CaseworkerChangedCriminalAssessmentToApproved = 35,
    CaseworkerChangedCriminalAssessmentToRejected = 36,
    CaseworkerChangedCriminalAssessmentToNotSet = 37,
    CaseworkerModifiedEducationalInstitution = 38,
    EducationalInstitutionAssociatedWithApplication = 39,
    CaseworkerChangedCodeOfConductToApproved = 40,
    CaseworkerChangedCodeOfConductToRejected = 41,
    CaseworkerChangedCodeOfConductToNotSet = 42,
    CaseworkerChangedMedicalAssessmentToApproved = 43,
    CaseworkerChangedMedicalAssessmentToApprovedWithConditions = 44,
    CaseworkerChangedMedicalAssessmentToRejected = 45,
    CaseworkerChangedMedicalAssessmentToNotSet = 46,
    ApplicationPaymentReceivedByOtherMeans = 47,
    ApplicationInvoiceMarkedAsAbandoned = 48,
    ApplicationInvoiceCreatedForOnlinePaymentForCitizen = 49,
    ApplicationInvoiceCreatedForCashPayment = 50,
    ApplicationInvoiceCreatedForElectronicInvoicePayment = 51,
    ApplicationInvoiceCreatedForMobilePayPayment = 52,
    ApplicationInvoiceCreatedForPaidByOtherMeans = 53,
    ApplicationInvoiceCreatedForOnlinePaymentForCompany = 54,
    ApplicationInvoiceCreatedForOnlineBulkPaymentForCompany = 55,
    ApplicationInvoiceCreatedForPartOfBulkPayment = 56,
    ApplicationPaymentReceivedOnlinePaymentForCompany = 57,
    ApplicationPaymentReceivedOnlineBulkPaymentForCompany = 58,
    ApplicationMarkedAsDeleted = 59,
    ApplicationImportedFromBat1 = 60,
    ApplicationImportedFromBat1AndOldCub = 61,
    CaseworkerSubmitApplicationSentToFrends = 62,
    PaymentRequestSentToFrends = 63,
    ApplicationCancelledDueToErrors = 64,
    ApplicationCancelledDueToErrorsSentToFrends = 65,
    CertificateCancelledDueToErrorsSentToFrends = 66,
    CaseworkerModifiedCommentOnApplicationSentToFrends = 67,
    SmartpostEducationalInstituionFailedCitizenSentToFrends = 68,
    ApplicationInvoiceCreatedForFreeOfChargePayment = 69,
    ApplicationCreatedBasedOnErrornousApplication = 70,
    ApplicationPaymentReceivedFreeOfCharge = 71,
    CertificateCancelledDueToErrorsOnCertificate = 72,
    CertificateReactivated = 73,
    CommentUpdated = 74,
    CertificateRevokedCancellationSentToFrends = 75,
    CertificateReactivatedSentToFrends = 76,
    ApplicationCancelledDueToFailedExaminationResult = 77,
    ApplicationRejectedSentToFrends = 78,
    ApplicationPaymentReceivedGiroFormBulkPaymentForOtherPayor = 79,
    ApplicationInvoiceCreatedForCompanyBulkPaymentGiroOrOnline = 80,
    ApplicationInvoiceCreatedForCompanyPaymentGiroOrOnline = 81,
    ApplicationPaymentReceivedGiroformBulkPaymentForCompany = 82,
    ApplicationPaymentReceivedGiroformPaymentForCompany = 83,
    ApplicationSubmittedOnBehalfOfApplicant = 84
}

// tslint:disable-next-line:no-namespace
export namespace ApplicationEventType {
	export function displayName(type: ApplicationEventType) {
		const values: { [index: number]: string } = {
			1: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONCREATED",
			3: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONEDITED",
			4: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONREQUIREMENTSFULFILLED",
			5: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONREJECTED",
			6: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONREADYFORCARDPRODUCTION",
			7: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONSENTTOCARDPRODUCTION",
			8: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONCERTIFICATEISSUED",
			9: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONCERTIFICATEEXPIRED",
			10: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONREQUESTEDREPLACEMENTCANCELLATION",
			11: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONREQUESTEDRENEWALCANCELLATION",
			12: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONREQUESTEDCHANGECANCELLATION",
			13: "ENUM_APPLICATIONEVENTTYPE_CERTIFICATEREVOKEDCANCELLATION",
			14: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONSUBMITTED",
			15: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONPAYMENTRECEIVEDONLINEPAYMENTFORCITIZEN",
			16: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONPAYMENTRECEIVEDCASH",
			17: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONPAYMENTRECEIVEDGIROFORM",
			18: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONPAYMENTRECEIVEDELECTRONICINVOICE",
			19: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONPAYMENTRECEIVEDMOBILEPAY",
			20: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONINVOICELETTERCREATED",
			21: "ENUM_APPLICATIONEVENTTYPE_CITIZENSUBMITAPPLICATIONSENTTOFRENDS",
			22: "ENUM_APPLICATIONEVENTTYPE_EDUCATIONALINSTITUTIONSUBMITAPPLICATIONSENTTOFRENDS",
			23: "ENUM_APPLICATIONEVENTTYPE_TEMPORARYCERTIFICATEANDPAYMENTREQUESTSENTTOFRENDS",
			24: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONCREATEDDUETOSELFSERVICEEXEMPTION",
			25: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONRESUBMITTEDBYCITIZEN",
			26: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONRETURNEDTOCITIZENFORRESUBMITTAL",
			27: "ENUM_APPLICATIONEVENTTYPE_CITIZENRESUBMITAPPLICATIONFORTAXSENTTOFRENDS",
			28: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONCREATEDBYCASEWORKERONBEHALFOFCITIZEN",
			29: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONCREATEDFORREORDERINGOFCERTIFICATE",
			30: "ENUM_APPLICATIONEVENTTYPE_TEMPORARYCERTIFICATEWITHOUTPAYMENTREQUESTSENTTOFRENDS",
			31: "ENUM_APPLICATIONEVENTTYPE_CASEWORKERREORDERSREPLACEMENTAPPLICATIONSENTTOFRENDS",
			32: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONRETURNEDTOEDUCATIONALINSTITUTIONFORRESUBMITTAL",
			33: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONRESUBMITTEDBYEDUCATIONALINSTITUTION",
			34: "ENUM_APPLICATIONEVENTTYPE_EDUCATIONALINSTITUTIONRESUBMITAPPLICATIONFORTAXSENTTOFRENDS",
			35: "ENUM_APPLICATIONEVENTTYPE_CASEWORKERCHANGEDCRIMINALASSESSMENTTOAPPROVED",
			36: "ENUM_APPLICATIONEVENTTYPE_CASEWORKERCHANGEDCRIMINALASSESSMENTTOREJECTED",
			37: "ENUM_APPLICATIONEVENTTYPE_CASEWORKERCHANGEDCRIMINALASSESSMENTTONOTSET",
			38: "ENUM_APPLICATIONEVENTTYPE_CASEWORKERMODIFIEDEDUCATIONALINSTITUTION",
			39: "ENUM_APPLICATIONEVENTTYPE_EDUCATIONALINSTITUTIONASSOCIATEDWITHAPPLICATION",
			40: "ENUM_APPLICATIONEVENTTYPE_CASEWORKERCHANGEDCODEOFCONDUCTTOAPPROVED",
			41: "ENUM_APPLICATIONEVENTTYPE_CASEWORKERCHANGEDCODEOFCONDUCTTOREJECTED",
			42: "ENUM_APPLICATIONEVENTTYPE_CASEWORKERCHANGEDCODEOFCONDUCTTONOTSET",
			43: "ENUM_APPLICATIONEVENTTYPE_CASEWORKERCHANGEDMEDICALASSESSMENTTOAPPROVED",
			44: "ENUM_APPLICATIONEVENTTYPE_CASEWORKERCHANGEDMEDICALASSESSMENTTOAPPROVEDWITHCONDITIONS",
			45: "ENUM_APPLICATIONEVENTTYPE_CASEWORKERCHANGEDMEDICALASSESSMENTTOREJECTED",
			46: "ENUM_APPLICATIONEVENTTYPE_CASEWORKERCHANGEDMEDICALASSESSMENTTONOTSET",
			47: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONPAYMENTRECEIVEDBYOTHERMEANS",
			48: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONINVOICEMARKEDASABANDONED",
			49: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONINVOICECREATEDFORONLINEPAYMENTFORCITIZEN",
			50: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONINVOICECREATEDFORCASHPAYMENT",
			51: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONINVOICECREATEDFORELECTRONICINVOICEPAYMENT",
			52: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONINVOICECREATEDFORMOBILEPAYPAYMENT",
			53: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONINVOICECREATEDFORPAIDBYOTHERMEANS",
			54: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONINVOICECREATEDFORONLINEPAYMENTFORCOMPANY",
			55: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONINVOICECREATEDFORONLINEBULKPAYMENTFORCOMPANY",
			56: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONINVOICECREATEDFORPARTOFBULKPAYMENT",
			57: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONPAYMENTRECEIVEDONLINEPAYMENTFORCOMPANY",
			58: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONPAYMENTRECEIVEDONLINEBULKPAYMENTFORCOMPANY",
			59: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONMARKEDASDELETED",
			60: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONIMPORTEDFROMBAT1",
			61: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONIMPORTEDFROMBAT1ANDOLDCUB",
			62: "ENUM_APPLICATIONEVENTTYPE_CASEWORKERSUBMITAPPLICATIONSENTTOFRENDS",
			63: "ENUM_APPLICATIONEVENTTYPE_PAYMENTREQUESTSENTTOFRENDS",
			64: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONCANCELLEDDUETOERRORS",
			65: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONCANCELLEDDUETOERRORSSENTTOFRENDS",
			66: "ENUM_APPLICATIONEVENTTYPE_CERTIFICATECANCELLEDDUETOERRORSSENTTOFRENDS",
			67: "ENUM_APPLICATIONEVENTTYPE_CASEWORKERMODIFIEDCOMMENTONAPPLICATIONSENTTOFRENDS",
			68: "ENUM_APPLICATIONEVENTTYPE_SMARTPOSTEDUCATIONALINSTITUIONFAILEDCITIZENSENTTOFRENDS",
			69: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONINVOICECREATEDFORFREEOFCHARGEPAYMENT",
			70: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONCREATEDBASEDONERRORNOUSAPPLICATION",
			71: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONPAYMENTRECEIVEDFREEOFCHARGE",
			72: "ENUM_APPLICATIONEVENTTYPE_CERTIFICATECANCELLEDDUETOERRORSONCERTIFICATE",
			73: "ENUM_APPLICATIONEVENTTYPE_CERTIFICATEREACTIVATED",
			74: "ENUM_APPLICATIONEVENTTYPE_COMMENTUPDATED",
			75: "ENUM_APPLICATIONEVENTTYPE_CERTIFICATEREVOKEDCANCELLATIONSENTTOFRENDS",
			76: "ENUM_APPLICATIONEVENTTYPE_CERTIFICATEREACTIVATEDSENTTOFRENDS",
			77: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONCANCELLEDDUETOFAILEDEXAMINATIONRESULT",
			78: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONREJECTEDSENTTOFRENDS",
			79: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONPAYMENTRECEIVEDGIROFORMBULKPAYMENTFOROTHERPAYOR",
			80: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONINVOICECREATEDFORCOMPANYBULKPAYMENTGIROORONLINE",
			81: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONINVOICECREATEDFORCOMPANYPAYMENTGIROORONLINE",
			82: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONPAYMENTRECEIVEDGIROFORMBULKPAYMENTFORCOMPANY",
			83: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONPAYMENTRECEIVEDGIROFORMPAYMENTFORCOMPANY",
			84: "ENUM_APPLICATIONEVENTTYPE_APPLICATIONSUBMITTEDONBEHALFOFAPPLICANT"
		}

		if (values.hasOwnProperty(type)) {
			return i18n.t(values[type])
		} else {
			return i18n.t(ApplicationEventType[type])
		}
	}
}
